(function (global, $, jcf, Si) {
    "use strict";

    Si.when('Ajax/SeasonGuide', 'Templates', 'Helpers').then(guidePage);

    function guidePage(SeasonGuide, Templates) {

        var controls = {},
            params = {},
            changeHandlers = {
                "country": countryChangeHandler,
                "tournament": tournamentChangeHandler,
                "season": seasonChangeHandler,
                "team": teamChangeHandler,
            },
            $listHolder = $('[data-list]'),
            $loader = $('[data-loader]'),
            $filterClearer = $('[data-filter-clear]');

        init();

        //init page, handlers and custom form elements
        function init() {

            inputReset();
            jcf.setOptions(
                'Select', {
                    wrapNative: false,
                    wrapNativeOnMobile: true
                }
            );
            jcf.replaceAll();

            initEventHandlers();
            //load default first chosen country and tournament / team and player to params array
            loadData();
            getData(
                {
                    'country': controls.country.val(),
                    'tournament': controls.tournament.val(),
                    'season': controls.season.val(),
                    'team': controls.team.val()
                }
            );
        }

        function initEventHandlers(){
            controls['all'] = $('[data-control]');
            $filterClearer.click(function(){
                countryChangeHandler.call(this, event);
            });
            controls['all'].each(
                function () {

                    var $ctrl = $(this),
                        name = $ctrl.data('control');
                    controls[$ctrl.data('control')] = $ctrl;
                    if ($ctrl.is('select')) {
                        $ctrl.data('lastValue', $ctrl.val());
                        $ctrl.on('change', getSelectChangeHandler(name));
                    } else {
                        $ctrl.on('change', changeHandlers[name]);
                    }
                }
            );
        }

        function inputReset() {

            $('[data-reset]').on('click', function(e) {
                e.preventDefault();
                var elements = $.trim( $(this).data('reset') ).split(','); // get resetable elements

                for (var i = 0; i < elements.length; i++) {
                    $(elements[i]).prop('selectedIndex',0);
                    jcf.refresh(elements[i]); // refresh custom selects
                }
                loadData();
                initEventHandlers();
            });
        }

        //get handler of select element change event
        function getSelectChangeHandler(name) {

            return function (event) {
                // check if value really changed
                var $ctrl = $(this),
                    newVal = $ctrl.val(),
                    lastVal = $ctrl.data('lastValue');
                if (newVal != lastVal) {
                    $ctrl.data('lastValue', newVal);
                    return changeHandlers[name].call(this, event);
                }
            };
        }


        //handlers
        function countryChangeHandler(event) {

            var curr_param = {};
            curr_param['country'] = controls.country.val();
            getData(curr_param);
        }

        function tournamentChangeHandler(event) {

            var curr_param = {};
            curr_param['tournament'] = controls.tournament.val();
            getData(curr_param);
        }

        function seasonChangeHandler(event) {

            var curr_param = {};
            curr_param['tournament'] = controls.tournament.val();
            curr_param['season'] = controls.season.val();
            getData(curr_param);
        }

        function teamChangeHandler(event) {

            loadData();
        }

        //!handlers


        //load data from form
        function loadData() {

            //change the name of tournament in header
            var tournament_name = controls.tournament[0].options[controls.tournament[0].selectedIndex].text;
            $('#tournament-name-header').html(tournament_name);

            params['country'] = controls.country.val();
            params['tournament'] = controls.tournament.val();
            params['season'] = controls.season.val();
            params['team'] = controls.team.val();
            if(params['team'] != ''){
                $('.team-guide').hide();
                $('.team-guide#team_block_'+params['team']).show();
            }else{
                $('.team-guide').show();
            }
        }

        //get array of values for next nested select and load it's first value as selected
        function getData(curr_param) {

            $loader.addClass('visible');
            return SeasonGuide.get(curr_param).then(
                function (response) {
                    updateControlsFromResponse(response);
                    updateTeamsList(response.teams, response.public_tour);
                    loadData();
                    $loader.removeClass('visible');
                }, function (status, error) {
                    console.log(status, error);
                    alert('Error appear while data loading...');
                    $loader.removeClass('visible');
                }
            );
        }


        function updateTeamsList(teams, isPublicTour){

            var data = {}, content = '';
            data['teams'] = teams;
            data['public_tour'] = isPublicTour;

            if (/^\/client/.test(global.location.pathname)) {
                content = Templates.make('client_season_guide_item.mustache', data);
            } else {
                content = Templates.make('season_guide_item.mustache', data);
            }

            $listHolder.empty();
            $listHolder.append(content);
        }

        //update form nested selects after response
        function updateControlsFromResponse(response) {

            if (response['tournaments']) {
                updateSelectOptions(controls.tournament, response['tournaments'], 'tournaments');
            }
            if (response['seasons']) {
                updateSelectOptions(controls.season, response['seasons'], 'seasons');
            }
            if (response['teams']) {
                updateSelectOptions(controls.team, response['teams'], 'teams');
            }
        }

        function updateSelectOptions($select, items, tplKey) {

            var tplData = {};
            tplData[tplKey] = items;
            $select.empty();
            var content = Templates.make('controls/season_review/' + tplKey + '-options.mustache', tplData);
            $select.append(content);
            getJcf($select).refresh();
        }
    }


    function getJcf(element) {

        return jcf.getInstance(element);
    }
})(window, jQuery, jcf, Si);
